import { Tooltip } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { creditBalanceStorage } from "e.sic-platform.webclient/src/services/shop/CreditBalanceStorage";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { Coin } from "../shop/Coin";
import { activityPricesStorage } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { authentication } from "e.sic-platform.webclient/src/services/authentication/Authentication";

export default observer(function CoinBalance() {
    const navigate = useNavigate();
    
    const goToShop = () => {
        navigate("/shop");
    };

    const color = creditBalanceStorage.balance < activityPricesStorage.analysisPrice ? "error" : "primary"
        
    if (authentication.anonymous) return (<></>)

    return (
        <Tooltip title={translationService.translate("general.go-to-shop")} sx={{ml: 1}}>
            <div style={{marginLeft:1}} onClick={goToShop}>
                <Coin color={color} text={translationService.translate("general.balance")} amount={creditBalanceStorage.balance} withBorder/>
            </div>
        </Tooltip>
    )
})